import React from 'react';
import { AddressResource, getSimpleAddresses } from 'src/helpers/api/addresses';
import { AnalyticsLoadingButton as LoadingButton } from 'src/components/Analytics';
import styles from 'src/components/ConfirmIdentityForm/ConfirmIdentityForm.scss';
import ClickableElement from 'src/components/ClickableElement';
import SelectionList from '@jg/selection-list';
import '@jg/selection-list/src/SelectionList.scss';
import { gbPostCodePattern } from 'src/components/ConfirmIdentityForm/confirmIdentityValidator';

interface Props {
  addAddressManually: () => void;
  selectUKAddress?: (address: AddressResource) => void;
}

interface State {
  postCodeAddresses: AddressResource[];
  postalCode: string;
  loading: boolean;
  errorMessage: string;
}

class GBPostcodeAddressLookup extends React.Component<Props, State> {
  state = {
    postalCode: '',
    postCodeAddresses: [],
    loading: false,
    errorMessage: '',
  };

  findAddress = async (postCode: string) => {
    this.setState({ loading: true });

    try {
      const data = await getSimpleAddresses(postCode);

      if (data) {
        this.setState({ postCodeAddresses: data.addresses });
      }
    } catch (err) {
      this.setState({
        errorMessage: 'An error has occurred, please try again',
      });
    }

    this.setState({ loading: false });
  };

  handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const postalCode = e.target.value;
    const isValidPostCode = gbPostCodePattern.test(postalCode);

    this.setState({
      postalCode,
      errorMessage: !isValidPostCode ? 'Please enter a valid postcode' : '',
    });
  };

  getFormattedAddresses = () => {
    return this.state.postCodeAddresses.map(
      (address: AddressResource, index: number) => {
        const summary =
          (address.addressLine1 ? address.addressLine1 : '') +
          (address.addressLine2 ? ', ' + address.addressLine2 : '') +
          (address.addressLine3 ? ', ' + address.addressLine3 : '') +
          (address.town ? ', ' + address.town : '') +
          (address.county ? ', ' + address.county : '') +
          (address.postcode ? ', ' + address.postcode : '');

        return {
          label: summary,
          isSelected: false,
          value: address,
        };
      }
    );
  };

  handleKeyDown = (e: React.KeyboardEvent<HTMLElement>) => {
    if (e.keyCode === 13) {
      e.preventDefault();
      this.findAddress(this.state.postalCode);
    }
  };

  render() {
    const { addAddressManually, selectUKAddress } = this.props;
    const hasError = this.state.postalCode && this.state.errorMessage;
    const addresses = this.getFormattedAddresses();

    return (
      <div className="row">
        <div className="col-sm-12 col-md-6">
          <div className="row">
            <div className="col-xs-6 col-md-8 jg-space-prmd@md">
              <div className="jg-form-group jg-space-mbn">
                <label className="jg-form-label" htmlFor="postalCode">
                  Postcode
                </label>
                <input
                  className={`jg-form-control ${
                    hasError ? 'jg-form-control--error' : ''
                  }`}
                  type="text"
                  id="postalCode"
                  value={this.state.postalCode}
                  onChange={this.handleChange}
                  onKeyDown={this.handleKeyDown}
                />
              </div>
            </div>

            <div className="col-xs-6 col-md-4 jg-space-pln@md">
              <div className="jg-form-group jg-space-mbn">
                <LoadingButton
                  className={`jg-btn jg-btn--brand ${styles.find}`}
                  loading={this.state.loading}
                  onClick={(e: React.MouseEvent<HTMLElement>) => {
                    e.preventDefault();
                    this.findAddress(this.state.postalCode);
                  }}
                  analyticsOptions={{
                    event: 'click',
                    subtype: 'button',
                    eventValue: 'look up postcode',
                    pageSection:
                      'page creation > begin your story > confirm your identity',
                  }}
                  value="Find"
                />
              </div>
            </div>
            <div className="col-sm-12">
              {hasError && (
                <span
                  className="jg-form-error-copy jg-text--small"
                  role="alert"
                >
                  {this.state.errorMessage}
                </span>
              )}
              <ClickableElement
                className="jg-text--link qa-manual-address jg-space-mtsm"
                onClick={addAddressManually}
              >
                Enter address manually
              </ClickableElement>
            </div>
          </div>
        </div>

        {addresses &&
          addresses.length > 0 && (
            <div className={styles.list}>
              <SelectionList
                items={this.getFormattedAddresses()}
                onChange={selectUKAddress}
              />
            </div>
          )}
      </div>
    );
  }
}

export default GBPostcodeAddressLookup;



// WEBPACK FOOTER //
// ./src/components/ConfirmIdentityForm/GBAddress/GBPostcodeAddressLookup.tsx